import { render, staticRenderFns } from "./DataLoad.vue?vue&type=template&id=8e78724c&"
import script from "./DataLoad.vue?vue&type=script&lang=js&"
export * from "./DataLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports